import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/pricing", label: "Pricing", testId: "nav-pricing-link" },
  { to: "/terms", label: "Terms & Conditions", testId: "nav-terms-link" },
  { to: "/acceptable-use", label: "Acceptable Use", testId: "nav-acceptable-use-link" },
  { to: "/privacy", label: "Privacy Policy", testId: "nav-privacy-link" },
  { to: "/contact", label: "Contact Us", testId: "nav-contact-link" },
];

export default function NavMenu() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <motion.button
        data-testid="hamburger-menu-button"
        aria-label={open ? "Close menu" : "Open menu"}
        onClick={() => setOpen((v) => !v)}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
        className="fixed left-5 top-5 z-[60] flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-black/40 text-white backdrop-blur-xl transition-colors duration-300 hover:border-white/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={open ? "x" : "menu"}
            initial={{ rotate: -90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: 90, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="flex"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </motion.span>
        </AnimatePresence>
      </motion.button>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed inset-0 z-50 bg-black/60 backdrop-blur-2xl"
            onClick={() => setOpen(false)}
          >
            <motion.nav
              data-lenis-prevent
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", stiffness: 90, damping: 20 }}
              className="flex h-full w-full max-w-md flex-col overflow-y-auto border-r border-white/10 px-10 py-10 sm:px-16"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="m-auto flex w-full flex-col gap-2">
              {LINKS.map((link, i) => (
                <div key={link.to} className="overflow-hidden pb-2">
                  <motion.div
                    initial={{ y: "115%" }}
                    animate={{ y: "0%" }}
                    exit={{ y: "115%" }}
                    transition={{
                      duration: 0.6,
                      delay: 0.15 + i * 0.08,
                      ease: [0.76, 0, 0.24, 1],
                    }}
                  >
                    <Link
                      to={link.to}
                      data-testid={link.testId}
                      onClick={() => setOpen(false)}
                      className={`group flex items-baseline gap-4 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 ${
                        location.pathname === link.to
                          ? "text-white"
                          : "text-white/50"
                      } transition-colors duration-300 hover:text-white`}
                    >
                      <span className="text-xs font-semibold tracking-[0.3em] text-white/40">
                        0{i + 1}
                      </span>
                      <span className="font-brand text-4xl leading-[1.08] tracking-wide sm:text-5xl sm:leading-[1.08]">
                        {link.label}
                      </span>
                    </Link>
                  </motion.div>
                </div>
              ))}
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ delay: 0.5 }}
                className="mt-10 text-xs font-medium tracking-[0.25em] text-white/35"
              >
                CHIPPYMATE.COM.AU
              </motion.p>
              </div>
            </motion.nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
